import { useState } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  trainingDescription: string
  maxChars?: number
}
export const Description = ({ trainingDescription, maxChars = 500 }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const expandable = trainingDescription.length > maxChars

  const expandableDescription =
    isExpanded || !expandable ? trainingDescription : trainingDescription.slice(0, maxChars) + '...'

  return (
    <Box gap="s8">
      <Text.Normal size="300">
        <div dangerouslySetInnerHTML={{ __html: String(expandableDescription) }} />
      </Text.Normal>
      {expandable && (
        <Box alignSelf="flexStart" cursor="pointer" onClick={() => setIsExpanded(!isExpanded)}>
          <Text.Normal underlined>
            {isExpanded
              ? i18n.t('trainings.my_training.show_less')
              : i18n.t('trainings.my_training.show_more')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}
